<template>
  <div class="logo-wrap" :class="{'horizontal': isHorizontal}">
    <div class="logo" :class="{'horizontal': isHorizontal}">
      <i class="icon icon--logo-new"  @click="toDashboard"></i>
      <div class="map-logo" @click="onClickJourneyLogo" :class="{'only-logo': onlyLogo}">
        <i class="icon icon--logo-new-journeymap-red">
          <i class="icon icon--logo-new-side" v-if="!onlyLogo" />
        </i>
      </div>
    </div>

    <template v-if="isOpenMapChanger">
      <div class="map-change-wrap" :class="{'horizontal': isHorizontal}" @mouseleave="onCloseMapChanger">
        <div
          class="map heatmap"
          @click="toHeatmap"
        >
          <i
            class="icon icon--logo-new-heatmap-red"
          />
        </div>
        <div class="journeymap map active"
             @click="toDashboard">
          <i class="icon icon--logo-new-journeymap-white" />
        </div>
        <div class="geo map"
             @click="toGeo">
          <i class="icon icon--logo-new-geo-red" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import { EventBus } from '@/libs/event-bus'
import { BEUSABLE_URL, createAuthUrl, GEO_URL } from '@/libs/utils'

export default {
  props: {
    isHorizontal: {
      type: Boolean,
      default: false
    },
    onlyLogo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpenMapChanger: false
    }
  },
  methods: {
    toGeo () {
      window.location.href = GEO_URL
    },
    toDashboard () {
      EventBus.$emit('onLoading', true)
      if (this.$route.name !== 'dashboard') {
        setTimeout(() => {
          this.$router.push({ name: 'dashboard' })
        }, 300)
      } else {
        location.href = '/tool'
      }
    },
    onClickJourneyLogo () {
      if (this.onlyLogo) {
        this.toDashboard()
      } else {
        this.isOpenMapChanger = true
      }
    },
    onCloseMapChanger () {
      this.isOpenMapChanger = false
    },
    toHeatmap () {
      if (this.$route.query.sid === 'f7f94f69d5') {
        window.location.href = 'https://samsung-tool.beusable.net/dashboard'
      } else {
        window.location.href = createAuthUrl(BEUSABLE_URL)
      }
    }
  }
}

</script>

<style scoped lang="scss">

.logo-wrap {
  display: inline-block;
  position: relative;

  &.horizontal {
    position: absolute;
  }
}

.logo {
  vertical-align: top;
  display: inline-block;
  flex-direction: column;
  position: relative;
  margin: 15px 29px 15px 9px;
  z-index: 10;
  cursor: pointer;
  width: 112px;

  &.horizontal {
    top: 15px;
    left: 16px;
    width: 241px;
    height: 22px;
    display: inline-block;
    transition: top 0.3s ease;
    margin: 0;
    position: relative;

    & .map-logo {
      display: inline-block;
      left: 117px;
      top: 0;
      margin: 0;
      position: absolute;
      padding-top: 6px;

      & .icon--logo-new-journeymap-red {
        height: 18px;
      }
    }

    & .icon--logo-new {
      position: relative;
    }
  }

  & .icon--logo-new {
    display: inline-block;
  }

  & .map-logo {
    width: 111px;
    height: 16px;
    padding: 4px;
    margin: 4px 0 0 -4px;

    &:not(.only-logo) {
      &:hover {
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.06);
      }
    }

    & .icon--logo-new-journeymap-red {
      display: inline-block;
      position: relative;
    }

    & .icon--logo-new-side {
      right: -10px;
      bottom: 2px;
      position: absolute;
    }
  }
}

.map-change-wrap {
  display: inline-block;
  position: absolute;
  top: 8px;
  left: 8px;
  width: 120px;
  height: 104px;
  z-index: 100;
  cursor: pointer;
  box-shadow: 0 8px 14px -2px rgba(0, 0, 0, 0.08);

  &.horizontal {
    left: 137px;
  }

  .map {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    background: #ffffff;
    box-sizing: border-box;
    height: calc(100% / 3);
    transition: all 0.2s ease-in-out;

    &:not(.active):hover {
      background: #ebebeb;
    }

    &.active {
      background: #ec0047;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.35) inset;
      border: none;
    }
  }

  .heatmap {
    border-radius: 6px 6px 0 0;
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }

  .journeymap {
    border-radius: 0;
    border-right: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
  }

  .geo {
    border-radius: 0 0 6px 6px;
    border-top: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    border-left: 1px solid #e0e0e0;
  }
}
</style>
